// Minimal markdown renderer: **bold** → <strong>; [text](url) flattened to "text (url)"
const renderInline = (text) => {
  const cleaned = (text || "").replace(/\[([^\]]+)\]\(([^)]+)\)/g, "$1 ($2)");
  const parts = cleaned.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((part, i) => {
    if (part.startsWith("**") && part.endsWith("**")) {
      return <strong key={`b-${i}`}>{part.slice(2, -2)}</strong>;
    }
    return <span key={`t-${i}`}>{part}</span>;
  });
};

export const ChatMessage = ({ role, content }) => {
  const isUser = role === "user";
  return (
    <div className={`flex ${isUser ? "justify-end" : "justify-start"}`}>
      <div
        data-testid={`chatbot-msg-${role}`}
        className={
          isUser
            ? "max-w-[80%] rounded-2xl rounded-br-sm bg-red-600 text-white px-3 py-2 text-sm whitespace-pre-wrap break-words"
            : "max-w-[85%] rounded-2xl rounded-bl-sm bg-white border border-slate-200 text-slate-800 px-3 py-2 text-sm whitespace-pre-wrap break-words shadow-sm"
        }
      >
        {renderInline(content)}
      </div>
    </div>
  );
};
